import styled from "styled-components"
import media from "styled-media-query"

const Circle = styled.span<{ correct?: boolean }>`
  border: solid 1px #0247aa;
  border-radius: 50%;
  display: block;
  height: 8px;
  width: 8px;
  ${media.greaterThan("small")`
    height: 12px;
    width: 12px;
  `}
`

export const FinishedCircle = styled(Circle)`
  background-color: ${props => (props.correct ? "#f8ba12" : "#e1ebfa")};
`

export const NowCircle = styled(Circle)`
  background-color: #0247aa;
  border: solid 1.5px #fff;
  box-shadow: 0 0 0 1px #0247aa;
  height: 12px;
  width: 12px;
  ${media.greaterThan("small")`
    border: solid 2.5px #fff;
    height: 17px;
    width: 17px;
  `}
`

export default Circle
